import { stringify } from 'qs';

export function createAuthorizationHeader(token) {
  return {
    Authorization: `Bearer ${token}`
  };
}

export function createUrl(uri, baseUrl, query) {
  let url = uri[0] !== '/' ? uri : uri.slice(1);
  const domainUrl =
    baseUrl[baseUrl.length - 1] !== '/' ? baseUrl : baseUrl.slice(0, baseUrl.length - 1);

  if (query) {
    url = `${url}?${stringify(query)}`;
  }

  return `${domainUrl}/${url}`;
}
